import { balanceLimit } from "../../../../Data/Dashboard/CryptoDashboard/CryptoDashboard";
import { H5, P } from "../../../../AbstractElements";

const BalanceLimit = () => {
  return (
    <div className="balance-limit">
      <div className="d-flex gap-2">
        {balanceLimit.map((data, i) => (
          <div className={`d-flex ${data.class}-balance-title gap-2`} key={i}>
            <H5>{data.percentage}</H5>
            <div className="limit-balance">
              <H5>{data.title}</H5>
              <P>{data.detail}</P>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BalanceLimit;
